import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ScrollArea from 'react-scrollbar';
import './SongList.css';

import { DataStore } from '../DataStore';

@observer
class SongList extends Component {

    onClickAddIcon = (event) => {
        let hash = event.target.getAttribute('hash');
        DataStore.addSongInList(hash);
        //console.log(DataStore.playSongList.slice());
    }

    onClickPlayIcon = (event) => {
        let hash = event.target.getAttribute('hash');
        DataStore.addSongAndPlay(hash);
        DataStore.isPlay = true;
    }

    onClickMore = (event) => {
        DataStore.page = DataStore.page + 1;
        DataStore.searchSongListStore();
    }

    canPlayHtml = (song) => {
        if(song.PlayUrl) {
            return (
                <li className="operate">
                    <button className="iconfont icon-add"
                        hash={song.Hash}
                        onClick={this.onClickAddIcon}></button>
                    <button className="iconfont icon-play"
                        hash={song.Hash}
                        onClick={this.onClickPlayIcon}></button>
                </li>
            )
        }else{
            return (
                <li className="operate">
                <span>已下架</span>
                </li>
            )
        }
    }

    ListItems = (list) => {
        //console.log(list);
        if(list.length > 0) {
            let listItems = [];
            for (let i = 0; i < list.length; i++) {
                listItems.push(
                    <ul className="song-list-row" key={list[i].Hash}>
                        <li className="sort">{i + 1}</li>
                        <li className="song-name ell">{list[i].SongName}</li>
                        <li className="singer-name ell">{list[i].SingerName}</li>
                        <li className="operate">
                            <button className="iconfont icon-add"
                                hash={list[i].Hash}
                                onClick={this.onClickAddIcon}></button>
                            <button className="iconfont icon-play"
                                hash={list[i].Hash}
                                onClick={this.onClickPlayIcon}></button>
                        </li>
                    </ul>
                )
            }
            
            if(DataStore.listType === 0 && !DataStore.lastPage) {
                listItems.push(
                    <div className="more-box" key={'morebutton'}>
                        <a onClick={this.onClickMore}>点击加载更多</a>
                    </div>
                );
            }

            return (<div className="song-list-body" 
                    style={{height:DataStore.scrollHeight + 'px'}}>
                    <ScrollArea
                        horizontal={false}>
                        {listItems}
                    </ScrollArea>
                    </div>); 
        }else{
            return (<div className="song-list-body">空空如也，赶紧去添加歌曲吧！</div>);
        }
    }

    componentDidMount = () => {
        DataStore.newSongListStore();
    }

    render() {

        return (
            <div className="song-list-main">
                <div className="song-list-header">
                    <ul className="song-list-row">
                        <li className="sort"></li>
                        <li className="song-name">歌曲</li>
                        <li className="singer-name">歌手</li>
                        <li className="operate"></li>
                    </ul>
                </div>
                {this.ListItems(DataStore.searchSongList.slice())}
            </div>
        );
    }
}

export default SongList;


// WEBPACK FOOTER //
// ./src/components/SongList.js